<template>
  <section :class="[
    { slider: `slider-${id}` },
    `article-product-promo`,
    {'slider_no-next-visible': !visibleNext}
  ]">
    <swiper ref="Swiper" :options="swiperOptions">
      <slot name="slides"></slot>
      <div class="swiper-slide swiper-slide--last">
        <article class="product-preview product-preview--last">
          <div class="product-preview__content">
            <div class="product-preview__image">
              <picture>
                <img src="/frontend/assets/img/product/agushonok-moloko.webp" alt="some alt text" loading="lazy">
              </picture>
            </div>
            <a class="article-product-promo__more" :href="href">{{ textsStore.getText('ArticleProductSlider__drugie_produkty') }}</a>
          </div>
        </article>
      </div>
    </swiper>
    <div class="slider__controls" :class="[{ 'g-hidden': slidesCount <= items && !isMobile }]">
      <div :class="['slider__prev', `slider-${id}__prev`]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M21 12L3 12"
            stroke="#005DAA"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M10 19L3 12L10 5"
            stroke="#005DAA"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div :class="['slider__next', `slider-${id}__next`]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M3 12L21 12"
            stroke="#005DAA"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M14 19L21 12L14 5"
            stroke="#005DAA"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
  </section>
</template>

<script>
import { useTextsStore } from "../stores/texts";

export default {
  name: "ArticleProductSlider2",
  setup() {
    return {
      textsStore: useTextsStore(),
    };
  },
  props: {
    id: { type: String, required: true, },
    items: { type: Number, default: 3, },
    visibleNext: { type: Boolean, default: false, },
    href: { type: String, required: true, },
  },
  data() {
    return {
      slidesCount: 1,
      swiperOptions: {
        slidesPerView: this.visibleNext ? 1.3 : 1,
        centerInsufficientSlides: true,
        spaceBetween: 8,
        watchOverflow: true,
        loopAdditionalSlides: 1,
        navigation: {
          prevEl: `.slider-${this.id}__prev`,
          nextEl: `.slider-${this.id}__next`,
          disabledClass: "is-disabled"
        },
        pagination: {
          el: `.slider-${this.id}__bullets`,
          type: "bullets",
          bulletClass: "slider__bullet",
          bulletActiveClass: "slider__bullet_active",
          clickable: true
        },
        breakpoints: {
          768: {
            spaceBetween: 20,
            slidesPerView: this.items,
          },
          1024: {
            spaceBetween: 20,
            slidesPerView: this.items,
          },
        }
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.Swiper.$swiper;
    },
    isMobile: function () {
      return this.$vssWidth < 768
    }
  },
  mounted() {
    this.slidesCount = this.$refs.Swiper.$children.length + 1;
  }
};
</script>

<style lang="scss">
@use '/frontend/scss/base/media.scss' as media;
@use '/frontend/scss/base/variables.scss' as var;

.article-product-promo {
  @include media.fluid('padding', 30px, 40px 30px);
  @include media.fluid('border-radius', 20px);
  background-color: rgb(202, 237, 255);
  margin: 0;
  padding: 0;

  &::before,&::after {
    display: none;
  }

  & .swiper-slide {
    height: auto;
  }

  & .swiper-slide--last {
    height: auto;
  }

  & .slider__prev,
  & .slider__next {
    display: flex;
    @include media.fluid('width', 56px);
    @include media.fluid('height', 56px);
    top: 50%;
    transform: translateY(-50%);
  }

  & .slider__prev {
    @include media.fluid('left', 12px);
  }

  & .slider__next {
    @include media.fluid('right', 12px);
  }

  & .product-preview--last {
    height: 100%;
  }

  & .product-preview--last .product-preview__content {
    height: 100%;
    gap: 0;
    justify-content: space-between;
  }

  & .product-preview--last img {
    @include media.fluid('width', 165px, 176px);
    @include media.fluid('padding-inline', 10px);
  }

  &__more {
    font-family: NotoSansGeorgian, Helvetica, Arial, sans-serif;
    font-weight: 700;
    background: rgba(0, 93, 170, 1);
    color: rgba(255, 255, 255, 1);
    @include media.fluid('border-radius', 80px);
    @include media.fluid('padding', 14px 20px);
    @include media.fluid('font-size', 16px);
  }
}
</style>
